import jwtDecode from 'jwt-decode'

const USER_TYPE_KEY = 'https://app.kampaay.com/userType'
const KAMPAAY_USER_ID_KEY = 'https://app.kampaay.com/kampaayUserId'
const GEOAREAS_KEY = 'https://app.kampaay.com/geoareas'
const ENVIRONMENT = 'https://app.kampaay.com/env'

type TokenUserType = 'pmi' | 'supplier'
type Auth0Environment = 'production' | 'staging' | 'demo'

type JwtToken = {
  [USER_TYPE_KEY]: TokenUserType
  [KAMPAAY_USER_ID_KEY]: number
  [GEOAREAS_KEY]: number[]
  [ENVIRONMENT]: Auth0Environment
}

export type DecodedJwt = {
  userType: TokenUserType
  kampaayUserId: number
  geoareas: number[]
  env: Auth0Environment
}

export const decodeJwt = (token: string): DecodedJwt => {
  const decoded = jwtDecode(token) as JwtToken
  const userType = decoded[USER_TYPE_KEY]
  const kampaayUserId = decoded[KAMPAAY_USER_ID_KEY]
  const env = decoded[ENVIRONMENT]
  let geoareas: number[] = []
  try {
    geoareas = decoded[GEOAREAS_KEY]
  } catch (error) {
    console.warn(
      `geoareas not set in current user JWT: ${decoded[GEOAREAS_KEY]}`
    )
  }
  // any unknown token userType is mapped as undefined
  return { userType, kampaayUserId, geoareas, env }
}
